import "../img/podcast/amazon-icon.svg";
import "../img/podcast/apple-icon.svg";
import "../img/podcast/spotify-icon.svg";
import "../img/podcast/soundcloud-icon.svg";
import "../img/podcast/youtube-icon.svg";

import "../img/podcast/bars.png";
import "../img/podcast/podcast-icon.png";
